<template>
    <v-container fluid>
        <v-row align='center' justify='center'>
            <v-card min-width='400' class='mt-16'>
                <v-card-text>
                    <AuthForm/>
                </v-card-text>
            </v-card>
        </v-row>
    </v-container>
</template>

<script>
import AuthForm from "@/components/AuthPageComponents/AuthForm.vue";

export default {
    name: "AuthPage",
    components: {AuthForm}
}
</script>